export const CONFIG_DATA = 'CONFIG_DATA';
export const UPDATE_CONFIGURED_RECORDSETS = 'UPDATE_CONFIGURED_RECORDSETS';
export const UPDATE_CUSTOM_SEARCHES = 'UPDATE_CUSTOM_SEARCHES';
export const ACTION_ARRAY = 'ACTION_ARRAY';
export const GET_DDL_LIST = 'GET_DDL_LIST';
export const LOG_OUT = 'LOG_OUT';
